import { faStore } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import PointSpreadLoading from 'react-loadingg/lib/PointSpreadLoading'
import { getLastSeenApi } from '../../Api/ClientServices'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'
import NumberOfOrder from '../../Component/NumberOfOrder/NumberOfOrder'
import { separate } from '../../Seprate/Seprate'
import Style from './LastSeen.module.css'
import { errorToast } from '../../Toast/Toast'
const LastSeen = () => {
    const[seen,setSeen]=useState()

    useEffect(()=>{
        getLastSeen()
    },[])

    const getLastSeen=async()=>{
        getLastSeenApi((succ,res)=>{
            if(succ){
              if(res.status===0){
                errorToast("مشکلی پیش آمده است")
              }else{
                setSeen(res.products)
              }
            }else{
              console.error(res)
            }
          })
    }
    let loading = null
    if(seen===undefined){
        loading=<div className={Style.SetLoading}><PointSpreadLoading color={'#ab0c59'} size={"small"} /></div>
    }
    else{
        loading=
        seen.map((item,index)=>{return(
            <li key={index} className={Style.productItem}>
                <div className={Style.imgHolder}>
                    <img src={`https://cdn.barest.ir/product/m/${item.id}.jpg`} alt={item.name}/>
                </div>
                <div className={Style.textHolder}>
                    <h2 className={Style.productName}>{item.name}</h2>
                    <h3 className={Style.supName}><FontAwesomeIcon className={Style.shopIcon} icon={faStore}/>{item.supplier}</h3>
                    <div className={Style.priceHolder}>
                        <h3 className={item.off_price==="0"?Style.price :Style.noPrice }><span>{separate(item.price)}</span>تومان</h3>
                        <h3 className={item.off_price==="0"?Style.noOffprice : Style.offprice}><span>{separate(item.price)}</span>تومان</h3>
                    </div>
                    <div className={Style.counter}>
                        <NumberOfOrder dataUpdate={getLastSeen} supId={item.supplier_id} data={item}/>
                    </div> 
                </div>
             </li> 
         )})
    }
    return (
        <div className={Style.pageHolder}>
            <BurgerMenuTitle title={"بازدیدهای اخیر"}/>
            <section className={Style.centerPart}>
                {/* <div className={Style.picHolder}>
                    <img src={"/Assets/Images/Products/lastseen.svg"} alt="آخرین بازدید"/>
                </div> */}
                <div className={Style.lastSeenPart}>
                    <ul className={Style.productsHolder}>
                        {loading}
                    </ul>
                </div>
            </section>
        </div>
    )
}

export default LastSeen
